<template>
  <!-- <div class="container"> -->
    <child/>
  <!-- </div> -->
</template>

<script>
export default {
  name: 'DefaultLayout'
}
</script>

<style lang="scss">
.default-layout {
  color: #636b6f;
  height: 100vh;
  font-weight: 100;
  position: relative;

  .links > a {
    color: #636b6f;
    padding: 0 25px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .1rem;
    text-decoration: none;
    text-transform: uppercase;
  }
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue